import React from 'react';
import PropTypes from 'prop-types';

import Panel from 'wonderbly-components/lib/Panel';

import { useGlobalContent, useOrder } from '../../hooks';
import { useParams } from 'react-router-dom';

import OrderButtons from '../Order/OrderButtons';
import OrderStatus from '../Order/OrderStatus';
import OrderDelivery from '../Order/OrderDelivery';
import OrderInformation from '../Order/OrderInformation';
import Loading from '../Loading';

import './OrderStatusCard.scss';

const OrderStatusCard = () => {
  const { orderNumber } = useParams();
  const { data, error, loading } = useOrder(orderNumber);
  const { http = {} } = useGlobalContent('errors');

  const { number, state, items, shipping } = data || {};

  return (
    <div className="order-status-card">
      <Panel border="shadow">
        {data && (
          <React.Fragment>
            <Panel.Section space="small">
              <div className="order-status-card__status">
                <OrderStatus status={state} isFlush />
              </div>
            </Panel.Section>
            <Panel.Section>
              <div className="order-status-card__delivery">
                <OrderDelivery delivery={shipping.delivery} />
              </div>
              <OrderInformation items={items} number={number} />
            </Panel.Section>
            <Panel.Section>
              <OrderButtons status={state}>
                {shipping.trackingLink && (
                  <OrderButtons.Track
                    isPrimary
                    state={data.state}
                    url={shipping.trackingLink}
                  />
                )}
                <OrderButtons.Help state={data.state} />
              </OrderButtons>
            </Panel.Section>
          </React.Fragment>
        )}
        {!data && (
          <Panel.Section>
            {error && http['500']}
            {loading && <Loading relative dark small />}
          </Panel.Section>
        )}
      </Panel>
    </div>
  );
};

OrderStatusCard.propTypes = {
  orderNumber: PropTypes.number.isRequired
};

export default OrderStatusCard;



// WEBPACK FOOTER //
// ./src/client/js/view/components/OrderStatusCard/OrderStatusCard.js